<script setup lang="ts">
import { storeToRefs } from 'pinia'
import AppVoipSessionLoader from './AppVoipSessionLoader.vue'
import { useGlobalLoadingStore } from '@/shared/stores/globalLoading'

const globalLoading = useGlobalLoadingStore()
const { active } = storeToRefs(globalLoading)
</script>

<template>
  <transition
    enter-active-class="transition-opacity duration-300 ease-out"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="transition-opacity duration-200 ease-in"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="active"
      class="pointer-events-auto fixed inset-0 z-[100]"
      role="status"
      aria-live="polite"
      aria-label="Loading"
      :aria-busy="active"
    >
      <AppVoipSessionLoader />
    </div>
  </transition>
</template>
